import { render, staticRenderFns } from "./BPReceivableCard.vue?vue&type=template&id=38bae699&"
import script from "./BPReceivableCard.vue?vue&type=script&lang=js&"
export * from "./BPReceivableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports